import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Dashboard, { DispatchProps, OwnProps, StateProps } from './Dashboard';
import { StoreState } from 'src/store/reducers';
import { fetchDashboardData } from 'src/store/actions/app-actions';
import { selectDashboardData } from 'src/store/selectors/app-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        dashBoardData: selectDashboardData(state),
        inProgress: state.app.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getDashboardData: () => dispatch(fetchDashboardData()),
    };
}

const DashboardScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(Dashboard);

export default DashboardScreen;
